import React from 'react';
import './ClerkServiceUnavailableScreen.css';

/**
 * Terminal service-unavailable screen for the Clerk rollout bootstrap.
 *
 * This screen is deliberately a DEAD END for ordinary visitors. It renders when
 * the backend reports that Clerk cannot be mounted while the rollout state makes
 * Clerk the required credential path (`BETA`/`ACTIVE`), or when the rollout status
 * itself could not be loaded and the frontend therefore cannot know which
 * credential path is permitted.
 *
 * It must NEVER offer, link to, or fall through to legacy credentials:
 *
 * - During `BETA`/`ACTIVE` the backend fails legacy login/register closed with
 *   `403 legacy_auth_unavailable`, so a legacy affordance here would be a dead
 *   link that leaks a false recovery path to users.
 * - Per the 2026-09-03 owner decision (Option A), emergency rollback restores
 *   backend endpoints only and operators reach legacy through a separate known
 *   entry that is deliberately outside this ordinary UI surface. The existence
 *   of that operator entry is NOT a reason to soften this screen.
 *
 * Copy here is provisional and pending owner approval.
 */
function ClerkServiceUnavailableScreen({ onRetry, isRetrying = false }) {
    if (typeof onRetry !== 'function') {
        throw new Error(
            'ClerkServiceUnavailableScreen requires an onRetry function; '
            + `received ${typeof onRetry}. The outage screen must always offer a retry path.`
        );
    }

    return (
        <main className="clerk-unavailable" role="alert" aria-label="Sign-in unavailable">
            <div className="clerk-unavailable__panel">
                <h1 className="clerk-unavailable__title">Sign-in is temporarily unavailable</h1>
                <p className="clerk-unavailable__message">
                    We can&apos;t reach the sign-in service right now. Your account and your
                    teams are safe &mdash; nothing has been lost. Please try again in a few moments.
                </p>
                <button
                    type="button"
                    className="clerk-unavailable__retry"
                    onClick={onRetry}
                    disabled={isRetrying === true}
                >
                    {isRetrying === true ? 'Retrying…' : 'Try again'}
                </button>
            </div>
        </main>
    );
}

export default ClerkServiceUnavailableScreen;
